<template>
    <thead v-bind:class="{'sticky': isTableVisible(scrollOffsetY, tablePosition)}" ref="thead">
        <tr :id="namespace + 'HeadTr'">
            <template v-for="(column, columnIndex) in columns">
                <template v-if="column.visible">
                    <th :data-label="column.label"
                        v-show="!(isColumnFixed(column.field) && isAnyFixedColumnsExist)"
                        v-on:mouseenter="onThHover(column.field)"
                        v-on:mouseleave="onThHover(column.field)"
                        v-bind:class="{'hidden': isColumnFixed(column.field) && isAnyFixedColumnsExist}"
                        v-bind:style="{'min-width': column.width, 'min-height': '25px'}"
                        :colspan="calculateColSpan(column)"
                        :rowspan="calculateRowSpan(column)"
                    >

                        <div class="column-header-wrapper">
                            <span v-visible="(isColumnHovered(column.field) && column.canBeFixed === true)"
                                  class="pin-fixed-column"
                                  @click="makeColumnFixed(column.field)"
                                  v-bind:class="{'fixed': isColumnFixed(column.field)}"></span>

                            <span @click="applySorting(column, columnIndex)">{{column.label}} {{column.sign}}</span>

                            <span class="sorting"
                                  v-visible="column.sort === true && (isColumnHovered(column.field) || getSortedColumn == column.field)">
                                <i class="sorting-top"
                                   @click="applySorting(column, columnIndex)"
                                   v-bind:class="{'active': getSortedColumn == column.field && getSortedColumnDirection == 'ASC'}"
                                   v-show="getSortedColumn != column.field || (getSortedColumn == column.field && getSortedColumnDirection == 'ASC')"
                                ></i>

                               <i class="sorting-bottom"
                                  @click="applySorting(column, columnIndex)"
                                  v-bind:class="{'active': getSortedColumn == column.field && getSortedColumnDirection == 'DESC'}"
                                  v-show="getSortedColumn != column.field || (getSortedColumn == column.field && getSortedColumnDirection == 'DESC')"
                               ></i>

                            </span>
                        </div>

                    </th>
                </template>

            </template>
        </tr>
        <tr :id="namespace + 'HeadTr2'">
            <template v-for="(column, columnIndex) in columns">
                <template v-if="column.isMetricValue">
                    <template v-for="date in getDates()">
                        <th>
                            <span>{{date}}</span>
                        </th>
                    </template>
                </template>
            </template>
        </tr>
    </thead>
</template>

<script>
    import '@/style/reports/base_table_style.scss';
    import tableCommonMixin from '@/components/reports/mixins/tableCommonMixin';
    import fixTableMixin from '@/components/reports/mixins/fixTableMixin';
    import sortTableMixin from '@/components/reports/mixins/sortTableMixin';
    import hoverTableMixin from '@/components/reports/mixins/hoverTableMixin';

    export default {
        name: "table-head",
        components: {},
        props: {
            data: {
                type: Array,
                required: true
            },
            columns: {
                type: Array,
                required: true
            },
            namespace: {
                type: String,
                required: true
            },

        },
        mixins: [
            tableCommonMixin,
            fixTableMixin,
            sortTableMixin,
            hoverTableMixin,
        ],
        data() {
            return {
                tablePosition: {offsetTop: null, clientHeight: null},
                deviceTopOffset: this.$md.mobile() !== null ? 0 : 60,
                interval: null,
            }
        },
        mounted() {

        },
        computed: {
            scrollOffsetY: function () {
                return this.$store.getters.getScrollOffsetY;
            }
        },
        watch: {
            scrollOffsetY: function (scrollOffsetY) {
                let vm = this;
                this.$nextTick(() => {
                    window.requestAnimationFrame(function () {
                        if ((scrollOffsetY > vm.tablePosition.offsetTop)) {
                            let offset = scrollOffsetY - vm.tablePosition.offsetTop - vm.deviceTopOffset;
                            vm.$refs.thead.style.transform = 'translateY(' + offset + 'px)';
                        }
                        else {
                            vm.$refs.thead.style.transform = 'translateY(0)';
                        }
                    });
                });
            }
        },
        methods: {
            calculateRowSpan(column) {
                return column.isMetricValue ? 1 : 2;
            },
            calculateColSpan(column) {
                if (column.isMetricValue)
                    return this.getDates().length;
                else
                    return 1;
            },
            getDates() {
                if (this.data.length < 1) return [];
                let row = this.data[0];
                let metrics = row.node.metrics;
                return metrics.map(item => item.date);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pin-fixed-column {
        width: 11px;
        height: 11px;
        margin-left: 2px;
        margin-right: 5px;
        background-image: url('/static/img/icon-pin.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;

        &.fixed {
            background-image: url('/static/img/icon-pin-fixed.svg');
        }
    }

    .sticky-header-column {
        position: relative;
        z-index: 2;
        transition: 0.3s;
    }

    .table > thead {
        will-change: transform;
        -webkit-transform: translateZ(0);

        &.sticky {
            position: sticky;
            will-change: transform;

            & > * {
                -webkit-transform: translateZ(0);
            }
        }

        &.stickyHeader {
            position: fixed;
            top: 0;
            transition: all .5s ease-in-out;
        }

        & > tr {
            text-align: left;

            & > th {
                padding: 5px 0 5px 5px;
                border: 1px solid $border-color;
                cursor: pointer;
                height: 40px;

                background: -moz-linear-gradient(top, #fbfbfb 5%, #ededed 100%); /* FF3.6-15 */
                background: -webkit-linear-gradient(top, #fbfbfb 5%, #ededed 100%); /* Chrome10-25,Safari5.1-6 */
                background: linear-gradient(to bottom, #fbfbfb 5%, #ededed 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fbfbfb', endColorstr='#ededed', GradientType=0); /* IE6-9 */
                background-repeat: no-repeat;

                & > div {
                    display: flex;
                    align-content: center;
                    align-self: center;
                    //align-items: baseline;
                }

                & > * {
                    font-family: $font-stack;
                    font-size: 13px;
                }

                &:hover {
                    background: #e7e7e7;
                }

                & + .hidden {
                    display: none;
                }

                & + .small {
                    min-width: 100px;
                    font-size: 12px;
                    font-weight: bold;
                    padding: 5px 10px 5px 10px;
                    text-align: left;
                }

                &.align-right {
                    vertical-align: top;
                }
            }

            & > th:first-child {
                border-left: 0;
            }

            & > th:last-child {
                border-right: 0;
            }

            &.datesRangeComparisonHeader {
                & > th {
                    background: #f3f3f3;
                    height: 40px;
                }
            }
        }
    }

    @include mobile-only {
        .table > thead {

            &.sticky {
                position: sticky;
                transition: none;

                & > * {
                    -webkit-transform: translateZ(0);
                    transform: translate3d(0px, 0px, 0px);
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/reports/rawDataPartnersReport/templates/customTableHead.vue